import { render, staticRenderFns } from "./PQModulePage.vue?vue&type=template&id=762a2b52&scoped=true"
import script from "./PQModulePage.vue?vue&type=script&lang=js"
export * from "./PQModulePage.vue?vue&type=script&lang=js"
import style0 from "./PQModulePage.vue?vue&type=style&index=0&id=762a2b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762a2b52",
  null
  
)

export default component.exports